export default function ComponentLevelDirective() {
  return {
    template: require('./component-level.html'),
    scope: {
      contributionComponentId: '=',
      componentLevel: '=',
      isEdit: '=',
      tooltipAppendToSelector: '@',
    },
    controller: 'ComponentLevelController',
    controllerAs: 'componentLevelVM',
    bindToController: true,
    replace: true
  };
}
